import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { ApiProperty } from '@nestjs/swagger';
import { IsISO8601, IsString, IsUUID } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import { BoardPurchaseInterface } from '../../board-purchase/interfaces/board-purchase.interface';
import { BoardPurchasePartialDeliveryInterface } from '../interfaces/board-purchase-partial-delivery.interface';

@Exclude()
export class BoardPurchasePartialDeliveryDto
  extends CommonEntityDto
  implements BoardPurchasePartialDeliveryInterface
{
  @ApiProperty({
    title: 'Notes',
    nullable: false,
    description: 'Notes',
  })
  @IsString()
  @Expose()
  notes!: string;

  @ApiProperty({
    type: 'string',
    nullable: false,
    format: 'date-time',
    title: 'Partial Delivery Date',
    description: 'The date and time of this partial delivery',
  })
  @IsISO8601({ strict: true })
  @Expose()
  partialDeliveryDate?: Date | undefined;

  @ApiProperty({
    format: 'uuid',
    title: 'Board Purchase Id',
    description: 'Board Purchase Id',
  })
  @IsUUID()
  @Expose()
  boardPurchaseId!: string;

  @ApiProperty({
    title: 'Board Purchase',
    description: 'Board Purchase',
  })
  @Expose()
  boardPurchase?: BoardPurchaseInterface | undefined;
}
